import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.set-prototype-of";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/*
 *
 * Sample usage:
 * <Impression
 *   id='chase-23'
 *   eventType='CC_IMPRESSION_EVENT'
 *   eventData={{
 *     impressionHeader: {
 *       vertical: 'Credit Card',
 *       linkType: 'details_link',
 *       offerVersionId: get(data, config.offerVersionId),
 *       productId: get(data, config.id),
 *       productInstance: 'react-card-template',
 *       productLocation: 'body',
 *       productPosition: position,
 *       productSlug: slug,
 *     }
 *   }}
 * >
 *   <CreditCardUnit/>
 * </Impression>
 *
 */
// Dependencies
import { Component } from 'react';
import PropTypes from 'prop-types'; // Local Dependencies

import withinViewport from '../../shared/in-viewport';
import wrapWithImpressionState from './impression-state';

var Impression =
/*#__PURE__*/
function (_Component) {
  _inherits(Impression, _Component);

  function Impression(props) {
    var _this;

    _classCallCheck(this, Impression);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Impression).call(this, props));
    _this.state = {
      impressionId: null
    };
    return _this;
  }

  _createClass(Impression, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var impressionId;

      if (typeof window !== 'undefined' && window.nwa) {
        // eslint-disable-next-line jsx-control-statements/jsx-jcs-no-undef -- directive added automatically by Shepherd migration
        impressionId = nwa.generatePageViewId();
      }

      this.setState({
        impressionId: impressionId
      });
      this.checkAndFire();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.checkAndFire();
    }
  }, {
    key: "checkAndFire",
    value: function checkAndFire() {
      var nwa = typeof window !== 'undefined' && window.nwa; // Attempt to fire tracking when we have a visible component
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      if (this.props.inViewport && !this.props.hasBeenTracked) {
        var eventData = _objectSpread({}, this.props.eventData); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration


        var header = this.props.extractImpressionHeader(eventData); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

        header.impressionId = this.state.impressionId; // Delete keys with null/undefined values

        eventData = JSON.parse(JSON.stringify(eventData));

        if (nwa) {
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          this.props.impressionReported(eventData); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

          nwa.track(this.props.eventName, eventData);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      return this.props.children || null;
    }
  }]);

  return Impression;
}(Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


Impression.displayName = 'Impression'; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

Impression.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types -- directive added automatically by Shepherd migration
  eventName: 'IMPRESSION_EVENT',
  extractImpressionHeader: function extractImpressionHeader(eventData) {
    return eventData.impressionHeader;
  }
}; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

Impression.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types -- directive added automatically by Shepherd migration
  id: PropTypes.string.isRequired,
  eventName: PropTypes.string.isRequired,
  hasBeenTracked: PropTypes.bool.isRequired,
  inViewport: PropTypes.bool.isRequired,
  impressionReported: PropTypes.func.isRequired,
  extractImpressionHeader: PropTypes.func,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  children: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types, react/require-default-props -- directive added automatically by Shepherd migration
  eventData: PropTypes.object
};
export default wrapWithImpressionState(withinViewport()(Impression));